import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <header className="bg-white border-b border-stone-100">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="terms-back">
            <img src="/yasamaru-64.png" alt="" className="w-8 h-8" />
            <span className="font-heading font-bold text-base text-stone-800">やさまるシフト</span>
          </Link>
          <Link to="/" className="text-xs text-stone-500 hover:text-stone-700 inline-flex items-center gap-1">
            <ArrowLeft className="w-3 h-3" />トップへ戻る
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-heading font-black text-3xl md:text-4xl text-stone-800 tracking-tight">利用規約・免責事項</h1>
        <p className="mt-2 text-xs text-stone-500">最終更新日:2026年2月15日</p>

        <div className="mt-10 space-y-8 text-sm text-stone-700 leading-relaxed">
          <Section title="第1条(適用)">
            <p>本規約は、株式会社フレッシュエージェント(以下「当社」)が提供するシフト管理サービス「やさまるシフト」(以下「本サービス」)の利用条件を定めるものです。利用者(以下「お客様」)は、本規約に同意のうえ本サービスを利用するものとします。</p>
          </Section>

          <Section title="第2条(利用登録)">
            <ul className="list-disc pl-5 space-y-1">
              <li>本サービスの利用希望者は、当社所定の方法で利用申込みを行うものとします。</li>
              <li>当社は、申込者が反社会的勢力に該当する場合や、虚偽の申告を行った場合、その他当社が不適切と判断した場合、利用登録を拒否することがあります。</li>
              <li>登録された情報に変更があった場合、お客様は速やかに当社に届け出るものとします。</li>
            </ul>
          </Section>

          <Section title="第3条(料金および支払い)">
            <ul className="list-disc pl-5 space-y-1">
              <li>本サービスは申込み日から60日間、無料でご利用いただけます(以下「無料トライアル」)。</li>
              <li>無料トライアル期間終了後、クレジットカードが登録されている場合は自動的に有料プラン(月額3,980円・税込)に移行します。</li>
              <li>カード未登録のまま無料トライアルが終了した場合、書き込み機能が一時停止します。データは終了日から30日間保持され、その間にカード登録いただければ再開可能です。30日経過後はデータを削除します。</li>
              <li>キャンペーンコードによる割引は、各キャンペーンの規約に従います。</li>
              <li>解約は本サービスの管理画面または問い合わせフォームより、いつでも可能です。日割り返金は行いません。</li>
            </ul>
          </Section>

          <Section title="第4条(禁止事項)">
            <p>お客様は、本サービスの利用にあたり、以下の行為を行ってはなりません。</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為に関連する行為</li>
              <li>本サービスの運営を妨害する行為</li>
              <li>他者になりすます行為、虚偽の情報を登録する行為</li>
              <li>本サービスをリバースエンジニアリングする行為</li>
              <li>本サービスを通じて取得した情報を、本サービスの目的以外に利用する行為</li>
              <li>その他、当社が不適切と判断する行為</li>
            </ul>
          </Section>

          <Section title="第5条(本サービスの提供の停止等)">
            <p>当社は、以下の場合、お客様への事前通知なく本サービスの全部または一部の提供を停止することがあります。</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>本サービスのシステム保守・更新を行う場合</li>
              <li>地震・落雷・火災・停電・天災等の不可抗力により本サービスの提供が困難な場合</li>
              <li>その他、当社が本サービスの提供が困難と判断した場合</li>
            </ul>
          </Section>

          <Section title="第6条(免責事項)">
            <ul className="list-disc pl-5 space-y-1">
              <li>当社は、本サービスに事実上または法律上の瑕疵がないことを明示的にも黙示的にも保証しておりません。</li>
              <li>当社は、本サービスに起因してお客様に生じたあらゆる損害について、当社の故意または重過失による場合を除き、一切の責任を負いません。</li>
              <li>当社が損害賠償責任を負う場合でも、その賠償額はお客様から受領した直近1ヶ月分の利用料金を上限とします。</li>
              <li>お客様と他のお客様または第三者との間で生じた紛争については、お客様の責任で解決していただきます。</li>
              <li>本サービスに含まれる AI 機能(代理入力・配置マジック等)の出力結果について、当社は正確性・適合性を保証しません。最終的な判断はお客様の責任で行ってください。</li>
            </ul>
          </Section>

          <Section title="第7条(サービス内容の変更)">
            <p>当社は、お客様に通知することなく、本サービスの内容を変更または提供を中止することができるものとし、これによってお客様に生じた損害について一切の責任を負いません。</p>
          </Section>

          <Section title="第8条(利用規約の変更)">
            <p>当社は、必要と判断した場合は、お客様に通知することなく本規約を変更することができるものとします。変更後の規約は、本サービス上に掲載した時点で効力を生じます。</p>
          </Section>

          <Section title="第9条(個人情報の取扱い)">
            <p>本サービスの利用によって取得する個人情報については、当社のプライバシーポリシーに従い適切に取り扱います。</p>
          </Section>

          <Section title="第10条(準拠法・裁判管轄)">
            <ul className="list-disc pl-5 space-y-1">
              <li>本規約の解釈にあたっては、日本法を準拠法とします。</li>
              <li>本サービスに関して紛争が生じた場合には、東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</li>
            </ul>
          </Section>

          <Section title="お問い合わせ">
            <div className="bg-white border border-stone-200 rounded-lg p-4 text-xs">
              <p><b>株式会社フレッシュエージェント</b></p>
              <p>本社所在地:東京都足立区</p>
              <p>お問い合わせは本サービスのお問い合わせフォームよりお願いいたします。</p>
            </div>
          </Section>
        </div>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading font-bold text-lg text-stone-800 mb-2">{title}</h2>
      {children}
    </section>
  );
}
